/**
 * NumericTextBox modules
 */
export * from './numerictextbox';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-inputs/src/numerictextbox/index.js
// module id = 814
// module chunks = 0